export default "__VITE_ASSET__CfaEU1kE__"